export const ROOT_ACTION = {
  SET_LOGIN_INFO: 'SET_LOGIN_INFO',
  SET_PERMISSION_LIST: 'SET_PERMISSION_LIST',
  SET_IS_ADMIN: 'SET_IS_ADMIN',
  SET_LOADING: 'SET_LOADING',
};
